<template>
  <el-tooltip class="item" effect="dark" content="按名称查询" placement="top">
    <el-select
            v-model="data"
            value-key="name"
            v-bind="$attrs"
            filterable
            remote
            :remote-method="search"
            :loading="loading"
            @change="onChange"
            @clear="onClean"
            ref="CityAutoComplete"
            placeholder="请输入城市名称"
    >
      <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item">
      </el-option>
    </el-select>
  </el-tooltip>
</template>
<script>
    import { getCities } from '@/service/site'
    // 目前不支持多选
    export default{
        props: {
            value: [Number, String],
            factorId: [Number, String],
            agentStatus: [Number],
            owned: {
                type: Boolean,
                default: false
            },
            initChooseFirst: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                data: null,
                loading: false,
                options: [],
                searchTimeOutHandle: null,
                result:[],
            }
        },
        created() {
            //this.search()
            //this.search(this.value, true)
        },
        watch: {
            value(val) {
                if (val !== this.data) {
                    this.search(val)
                }
            },
            factorId() {
                this.onClean()
                this.search('')
            },
            agentStatus() {
                this.onClean()
                this.search('')
            }
        },
        methods: {
            search(query, isInit = false) {
                this.loading = true
                clearTimeout(this.searchTimeOutHandle)
                let conditions = {}
                if (!!query) {
                    conditions.name = query
                }
                conditions.show_levels_info=1
                let that = this
                let timeout = isInit ? 0 : 300
                this.searchTimeOutHandle = setTimeout(() => {
                    getCities(conditions).then(async (response) => {
                        that.loading = false
                        that.options = response
                        that.data = null

                        that.onChange()
                        if (isInit) {
                            that.$emit('created', that.data)
                        }
                    }).catch(err => {
                        console.log(err)
                        that.loading = false
                    })
                }, timeout)
            },
            onChange(item) {
                if(!!item){
                    this.$emit('getEmit', item)
                }
            },
            onClean() {
                // this.options = []
                this.data = null
                this.$emit('input', '')
            },
            reset () {
                this.search(this.value, true)
            }
        },
    }
</script>
